import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs, TabList, Tab } from '@parrot/ui';

export interface UniverseTab {
  /** URL segment under the base route, e.g. 'leaderboard'. */
  id: string;
  label: string;
}

export interface UniverseTabsProps {
  /** Route the tabs hang off, e.g. '/titles'. */
  baseRoute: string;
  tabs: UniverseTab[];
  /** Query string kept across tab switches, e.g. "?region=UCAN". */
  search?: string;
}

/**
 * Tab bar for a universe page (Titles, Platforms). Uses @parrot/ui Tabs wired to
 * URL navigation: the active tab is read from the path, and selecting one routes
 * to `${baseRoute}/${tab.id}`. Mirrors ip-intelligence's UniverseTabs.
 */
export function UniverseTabs({ baseRoute, tabs, search = '' }: UniverseTabsProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab =
    tabs.find((t) => location.pathname.endsWith(`/${t.id}`))?.id ?? tabs[0]?.id ?? '';

  const handleChange = (tabId: string) => {
    const tab = tabs.find((t) => t.id === tabId);
    if (tab) navigate(`${baseRoute}/${tab.id}${search}`);
  };

  return (
    <Tabs value={activeTab} onValueChange={handleChange}>
      <TabList>
        {tabs.map((t) => (
          <Tab key={t.id} value={t.id}>
            {t.label}
          </Tab>
        ))}
      </TabList>
    </Tabs>
  );
}
